/**
 * Converts a base64-encoded string to a Blob object with the specified MIME type.
 *
 * @param base64 - The base64-encoded string to convert.
 * @param mimeType - The MIME type of the resulting Blob.
 * @returns A Blob representing the decoded binary data.
 */
export function base64ToBlob(base64: string, mimeType: string): Blob {
  const byteCharacters: string = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i: number = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}
